export const aICompetitionProvidersTypes = {
    methodica: {
        providerId: "e55fc6e6-7be3-4829-9865-f2305865cbdc",
        name: "methodica"
    },
    digitalCuratorship: {
        providerId: "a1311cc6-7cae-460e-8f5a-973ac6c9a2f7",
        name: "digitalCuratorship"
    }
}